module.exports = __webpack_public_path__ + "static/media/daily_check_background_top_left.98b4db3f.svg";